<style scoped>
    .sms-container{
        border-bottom: 1px solid #dddee1;
        margin-bottom: 10px;
        padding-bottom: 20px;
    }
    .sms-content{
        white-space: normal;
    }
    .sms-input-container{
        max-width: 600px;
    }
    .search-customer-input{
        display: inline-block;
        width: 300px;
    }
    .history-title{
        font-weight: bold;
    }
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
    }
    .item{
        position: relative;
        display: inline-block;
        padding: 6px 12px;
        margin-right: 5px;
        margin-bottom: 5px;
        border: 1px solid #dddee1;
        text-align: left;
        transition: .3s;
        -webkit-transition: .3s;
        cursor: pointer;
    }
    .item:hover{
        box-shadow: 0 2px 2px rgba(120,120,120,.4);
        transform: scale(1.05,1.05);
    }
    .item-selected{
        background: #e5e5e5;
        color: #aaa;
        cursor: auto;
    }
    .item-selected:hover{
        box-shadow: none;
        transform: scale(1,1);
    }
    .item:hover .del-btn{
        display: inline-block;
    }
    .del-btn{
        display: none;
        position: absolute;
        top: 2px;
        right: 8px;
        font-size: 18px;
        background: white;
    }
    .del-btn:hover{
        color: #2b85e4;
        cursor: pointer;
    }
</style>
<template>
  <div>
    <div class="line sms-container">
      <h2>批量发送短信</h2>
      <div class="line sms-input-container">
        <Tooltip
          placement="right"
          always
        >
          <Row>
            <i-col span="10" />
            <div>内容</div>
            <Input
              v-model="sms_hash.title"
              type="textarea"
              placeholder="请输入..."
            />
            </i-col>
            <i-col span="6" />
            <div>联系人</div>
            <Input
              v-model="sms_hash.user"
              type="textarea"
              placeholder="请输入..."
            />
            </i-col>
            <i-col span="8" />
            <div>联系方式</div>
            <Input
              v-model="sms_hash.contact"
              type="textarea"
              placeholder="请输入..."
            />
            </i-col>
          </Row>
          <div slot="content">
            <span class="sms-content">
              {{ smsContent }}
            </span>
          </div>
        </Tooltip>
      </div>
      <div class="line">
        <Row>
          <i-col span="12" />
          <div class="search-customer-input">
            <Input
              v-model="search_customer_params.search"
              type="textarea"
              autosize
              :rows="1"
              placeholder="搜索员工, 多个请以空格分割"
            />
          </div>
          <Ajaxbtn
            ref="customerSearchBtn"
            :url="search_customer_path"
            :params="search_customer_params"
            type="search"
            @done="handleCustomerData"
            @fail="handleCustomerFail"
          />
          <div class="line">
            <div
              v-for="customer in search_customers"
              :key="customer.id"
              class="item"
              :class="{'item-selected': isSelected(customer)}"
              @click="selectCustomer(customer)"
            >
              <span>{{ customer.account }} - </span>
              <span>{{ customer.mobile }}</span>
            </div>
          </div>
          </i-col>
          <i-col span="12" />
          <h2>
            已选择:
            <Button
              v-show="select_customers.length"
              type="warning"
              size="small"
              @click="clearSelect"
            >
              清除
            </Button>
          </h2>
          <div class="line">
            <div
              v-for="(customer, index) in select_customers"
              :key="customer.id"
              class="item"
            >
              <span>{{ customer.account }} - </span>
              <span>{{ customer.mobile }}</span>
              <span
                class="del-btn"
                @click="unSelectCustomer(index)"
              >
                <Icon type="md-close" />
              </span>
            </div>
          </div>

          <Ajaxbtn
            v-show="select_customers.length"
            :url="batch_send_sms_path"
            :params="batch_send_sms_params"
            :config="send_sms_config"
            @done="handleSendDone"
            @fail="handleSendFail"
          />
          </i-col>
        </Row>
      </div>
    </div>
    <div class="line">
      <span class="history-title">短信发送历史</span>
      <Select
        v-model.number="params.status"
        placeholder="记录类型"
        style="width: 100px"
        @on-change="doSearch"
      >
        <Option :value="0">
          失败的
        </Option>
        <Option :value="1">
          成功的
        </Option>
        <Option :value="2">
          所有记录
        </Option>
      </Select>
      <div class="search-input">
        <Input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="get_logs_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <div class="list-container">
      <Table
        ref="table"
        border
        :columns="log_columns"
        :data="logs"
        :no-data-text="empty_tip"
        size="small"
      />
      <Backdrop v-show="loading" />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/fin/send_sms">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/fin/send_sms',
    /* router_info_end */

    data() {
      return {
        get_logs_path: Util.api.get_sms_logs,
        search_customer_path: Util.api.query_customer_with_contact,
        loading: false,
        empty_tip: '获取数据中...',
        params: {
          per_page: 20,
          page: 1,
          search: '',
          status: 2,
          tpl_id: 1964220
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        logs: [],
        log_columns: [
          {
            title: '状态',
            key: 'status',
            width: 50,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              if (row.status) {
                ret.push(h('div', {
                  'class': {
                    'color-success': true
                  }
                }, '成功'));
              } else {
                ret.push(h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '失败'));
              }

              return h('div', ret);
            }
          },
          {
            title: '发送时间',
            width: 140,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', moment(row.created_at).format('YYYY-MM-DD HH:mm:ss')));
              return h('div', ret);
            }
          },
          {
            title: 'tpl_id',
            width: 80,
            key: 'tpl_id'
          },
          {
            title: '姓名',
            width: 80,
            key: 'user'
          },
          {
            title: '手机',
            width: 100,
            key: 'mobile'
          },
          {
            title: '短信内容',
            key: 'params',
            render: (h, params) => {
              const row = params.row;
              const sms_hash = JSON.parse(row.params.replace(/\"\=\>\"/g, '":"'));
              const sms_content = `【百词斩财务】财务提醒您：${sms_hash.title}, 请尽快处理.
                                              详情请咨询 ${sms_hash.user}, 联系方式 ${sms_hash.contact}.`;
              return h('div', sms_content);
            }
          },
          {
            title: '日志',
            key: 'result'
          },
          {
            title: '操作',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              if (!row.status && row.result === 'fail') {
                ret.push(h('Poptip', {
                  props: {
                    confirm: true,
                    title: '确定重试?',
                  },
                  on: {
                    'on-ok': () => {
                      this.retry(row);
                    }
                  }
                }, [h('Button', {
                  props: {
                    size: 'small'
                  }
                }, '重试')]));
              }
              return h('div', ret);
            }
          },
        ],

        sms_hash: {
          title: '',
          user: '',
          contact: ''
        },
        search_customer_params: {
          search: ''
        },
        select_customers: [],
        search_customers: [],
        batch_send_sms_path: Util.api.batch_send_sms,
        send_sms_config: {
          icon: 'paper-airplane',
          method: 'post',
          name: '发送',
          processingName: '发送中...',
          successedName: '发送成功',
          failedName: '发送失败',
          checkCallback: this.checkValid
        }
      }
    },
    computed: {
      smsContent() {
        return `【百词斩财务】财务提醒您：${this.sms_hash.title}, 请尽快处理.
                详情请咨询 ${this.sms_hash.user}, 联系方式 ${this.sms_hash.contact}.`
      },
      batch_send_sms_params() {
        return {
          tpl_id: this.params.tpl_id,
          sms_hash: this.sms_hash,
          customers: this.select_customers
        }
      }
    },
    created() {
      this.getLogs();
    },
    mounted() {
      //
    },
    methods: {
      getLogs() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          Util.ajax.get(this.get_logs_path, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.loading = false;
            if (res.code === 1) {
              const data = res.data;
              this.handleData(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.empty_tip = '搜索结果中...';
        this.logs = [];
      },
      handleData(data) {
        this.loading = false;
        this.logs = [];
        data.logs.forEach((log) => {
          log.is_retry = false;
          this.logs.push(log);
        });
        if (data.logs.length === 0) {
          this.empty_tip = '没有结果, 请重试!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.empty_tip = '搜索失败, 请重试';
        console.log(e);
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getLogs();
      },
      retry(sms_log) {
        const result_cache = sms_log.result;
        sms_log.result = '重试中...';
        sms_log.is_retry = true;
        Util.ajax.post(Util.api.retry_sms, {
          id: sms_log.id
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            setTimeout(() => {
              data.is_retry = false;
              sms_log.result = data.result;
              sms_log.status = data.status;
              if (!data.status) {
                this.$Message.error('重试失败!');
              }
            }, 800);
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          sms_log.result = result_cache;
          sms_log.is_retry = false;
          console.log(e);
        });
      },
      doCustomerSearch() {
        this.$refs.customerSearchBtn.doAjax();
      },
      handleCustomerData(customers) {
        this.search_customers = [];
        customers.forEach((customer) => {
          this.search_customers.push(customer);
        })
      },
      handleCustomerFail(e) {
        //
      },
      isSelected(customer) {
        const len = this.select_customers.length;
        for (let i = 0; i < len; i++) {
          if (this.select_customers[i].id === customer.id) {
            return true;
          }
        }
        return false;
      },
      selectCustomer(customer) {
        if (!this.isSelected(customer)) {
          this.select_customers.push(customer);
        }
      },
      unSelectCustomer(index) {
        this.select_customers.splice(index, 1);
      },
      clearSelect() {
        this.select_customers = [];
      },
      checkValid() {
        let err_msg = '';
        Object.keys(this.sms_hash).forEach((key) => {
          if (!this.sms_hash[key].trim()) {
            err_msg += '<p>输入框不能为空</p>';
          }
        });
        if (this.select_customers.length === 0) {
          err_msg += '<p>请选择接收短信的人</p>';
        }
        if (err_msg) {
          this.$Modal.error({title: '提醒', content: err_msg});
          return false;
        }
        return true;
      },
      handleSendDone(data) {
        console.log(data);
        if (data.code === 1) {
          this.params.page = 1;
          this.params.search = '';
          this.doSearch();
          let err_msg = '';
          data.customers.forEach((customer) => {
            if (!customer.is_succeed) {
              err_msg += '<p>' + customer.account + '-' + customer.mobile + ' 发送失败!</p>'
            }
          });
          if (err_msg) {
            this.$Modal.error({title: '提示', content: err_msg})
          } else {
            this.$Modal.success({title: '提示', content: '全部发送成功!'})
          }
        } else {
          this.$Modal.error({title: '提示', content: data.msg})
        }
      },
      handleSendFail(e) {
        console.log(e);
      }
    }
  }
</script>
